export enum TipoDataClipping {
    DIA = "DIA",
    MES = "MES",
    ANO = "ANO",
    SEIS_MESES = "SEIS_MESES",
    DOZE_MESES = "DOZE_MESES"
}
